import React from 'react';

import { useIntl } from 'react-intl';

import { BarToolTip } from '../BarToolTip';

export function AdsProvider() {
  const { messages } = useIntl();

  return (
    <BarToolTip title={messages.locales.headers.aaCampaigns}>
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.78012 10.0566V9.37436C7.46648 9.37436 5.0223 9.86168 5.0223 12.5464C5.0223 13.9065 5.738 14.828 6.96684 14.828C7.86709 14.828 8.67281 14.283 9.18145 13.397C9.81163 12.3072 9.78012 11.2838 9.78012 10.0566ZM13.0075 17.7342C12.796 17.9203 12.4899 17.9335 12.2513 17.8095C11.189 16.9412 11 16.538 10.4148 15.7096C8.65931 17.4728 7.41697 18 5.13933 18C2.44758 18 0.350006 16.3652 0.350006 13.0913C0.350006 10.5351 1.7589 8.79399 3.76195 7.94339C5.49943 7.19025 7.92561 7.05735 9.78012 6.84913V6.44155C9.78012 5.69284 9.83864 4.80679 9.39301 4.15998C9.0014 3.57962 8.2542 3.34039 7.59701 3.34039C6.37718 3.34039 5.28787 3.95619 5.0223 5.23209C4.96828 5.51563 4.75673 5.79473 4.46865 5.80802L1.36279 5.48019C1.10171 5.4226 0.813634 5.21437 0.885654 4.82009C1.60135 1.11642 4.99979 0 8.04264 0C9.60007 0 11.6346 0.407581 12.8635 1.5683C14.4209 2.99926 14.2724 4.90869 14.2724 6.98646V11.8952C14.2724 13.3704 14.8935 14.0172 15.4787 14.8147C15.6858 15.0982 15.7308 15.4393 15.4697 15.652C14.817 16.188 13.6557 17.1848 13.0165 17.743L13.0075 17.7342Z" fill="white" />
      </svg>
    </BarToolTip>
  );
}
